import { getCategoryByQuery } from "../config/navigation";
import { slugifyKind } from "./categoryKindRoutes";

export const getProductSlug = (product) => {
  if (typeof product === "string") return product.trim();

  return String(
    product?.slug || product?.productSlug || product?.product?.slug || "",
  ).trim();
};

const getFirstProductValue = (value) => {
  if (Array.isArray(value)) {
    const firstValue = value.find((item) => String(item ?? "").trim());
    return firstValue == null ? "" : String(firstValue).trim();
  }

  return value == null ? "" : String(value).trim();
};

const getProductCategoryValue = (product, options = {}) =>
  getFirstProductValue(
    options.category ?? product?.category ?? product?.product?.category,
  );

const getProductKindValue = (product, options = {}) =>
  getFirstProductValue(options.kind ?? product?.kind ?? product?.product?.kind);

export const getProductManufacturer = (product, options = {}) =>
  getFirstProductValue(
    options.manufacturer ??
      product?.manufacturer ??
      product?.brand ??
      product?.product?.manufacturer ??
      product?.product?.brand,
  );

const BRAND_SLUG_CHAR_MAP = {
  а: "a",
  б: "b",
  в: "v",
  г: "h",
  ґ: "g",
  д: "d",
  е: "e",
  є: "ye",
  ж: "zh",
  з: "z",
  и: "i",
  і: "i",
  ї: "yi",
  й: "j",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "h",
  ц: "c",
  ч: "ch",
  ш: "sh",
  щ: "shch",
  ю: "yu",
  я: "ya",
  ь: "",
  ъ: "",
  ы: "y",
  э: "e",
  ё: "e",
};

export const slugifyBrand = (brandValue = "") =>
  String(brandValue)
    .trim()
    .toLowerCase()
    .replace(/[’`ʼ]/g, "'")
    .replace(/[а-яіїєґёъыэь]/g, (char) => BRAND_SLUG_CHAR_MAP[char] ?? char)
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9']+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-");

export const buildBrandPath = (brandValue) => {
  const brand = slugifyBrand(brandValue);

  return brand ? `/brands/${encodeURIComponent(brand)}` : "/products";
};

export const getProductVariantId = (product) => {
  const value =
    product?.variantId ??
    product?._id ??
    product?.productId ??
    product?.product?._id;

  return value == null ? "" : String(value).trim();
};

export const buildProductDetailPath = (productOrSlug, options = {}) => {
  const slug = getProductSlug(productOrSlug);

  const product =
    typeof productOrSlug === "string" ? {} : productOrSlug || {};
  const productCode =
    options.productCode ??
    product?.productCode ??
    product?.product?.productCode;
  if (!slug) {
    const code = Number(product?.productCode ?? product?.product?.productCode ?? productCode);
    if (!Number.isSafeInteger(code) || code <= 0) return "";
    const params = new URLSearchParams({ productCode: String(productCode ?? code) });
    return `/product/code/${code}?${params.toString()}`;
  }
  const categoryItem = getCategoryByQuery(
    getProductCategoryValue(product, options),
  );
  const kindSlug = slugifyKind(getProductKindValue(product, options));
  const manufacturer = getProductManufacturer(product, options);
  const manufacturerSlug = slugifyBrand(manufacturer);
  const params = new URLSearchParams();

  if (productCode) params.set("productCode", String(productCode));

  const query = params.toString();
  const detailPath =
    categoryItem?.slug && kindSlug && manufacturerSlug
      ? `/category/${categoryItem.slug}/${kindSlug}/${encodeURIComponent(
          manufacturerSlug,
        )}/${encodeURIComponent(slug)}`
      : `/products/${encodeURIComponent(slug)}`;

  return `${detailPath}${query ? `?${query}` : ""}`;
};
